import { Component, OnInit } from '@angular/core';
import { AccountService } from "../../../Utils/_services/account/account.service";
import { FormsModule } from '@angular/forms';
import { NgIf, AsyncPipe, CommonModule, TitleCasePipe, NgFor } from '@angular/common';
import { Observable, of } from 'rxjs';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AppManagementService } from '../../../Utils/_services/app-management/app-management.service';
import { ICustomError } from '../../../Utils/_models/network-response';
import { IBodyFeatureProduct } from './body.model';
import { IAppManagementEntityDto } from '../../../Utils/_services/app-management/app-management.model';


@Component({
  selector: 'body-content-item',
  standalone: true,
  imports: [
    NgFor,
    NgIf
  ],
  templateUrl: './body.component.html',
  styleUrl: './body.component.css'
})
export class BodyContentItemComponent implements OnInit {

  // properties
  apps: IAppManagementEntityDto[] = [];
  groupedApps: IAppManagementEntityDto[][] = [];
  featureProduct?: IBodyFeatureProduct;
  isAnyFeatureProducts: boolean = false;

  constructor(private appService: AppManagementService) {}

  ngOnInit(): void {
    this.loadApps();
  }

  loadApps(): void {
    this.appService.getAllApps().subscribe({
      next: (response) => {
        this.apps = response.data;
        this.groupAppsForCarousel();
        this.getFeatureProduct();
      },
      error: (err: ICustomError) => {
        console.error('Failed to load apps:', err.error.msg);
        alert('Error loading apps. Please try again.');
      }
    });
  }

  groupAppsForCarousel(): void {
    const groupSize = 3; // 3 items per carousel slide
    for (let i = 0; i < this.apps.length; i += groupSize) {
      this.groupedApps.push(this.apps.slice(i, i + groupSize));
    }
  }

  /**
   * Quick feature, will make better later. Where can toggle which to show from admin panel
   */
  getFeatureProduct(): void {
    if (this.apps.length) {
      const data = this.apps.find((x => x.isFeatureApp));
      if (data) {
         this.featureProduct = {
          Tag: "Revolutionary Platform",
          Features: ["AI-Powered Job Matching", "Automated Applications", "Smart Profile Optimization"],
          Title: data.title,
          LogoUrl: data.logoUrl,
          Description: data.description,
          WebsiteUrl: data.websiteUrl
         }
      }
    }
  }

  openWebsite(url: string | null): void {
    if (url) {
      window.open(url, '_blank');
    }
  }
  visitMaxgeneye() {
    const url = this.featureProduct?.WebsiteUrl ?? "https://www.insizon.com/#";
    window.open(url, "_blank")
  }

  //TODO: Add a featureProduct table in backend, that will store image size, fontsize, etc
  getFeatureLogo() {
    const url = this.featureProduct?.LogoUrl ?? "https://insizon-email-templates-bucket.s3.us-east-2.amazonaws.com/maxgeneye/maxgeneye-logo-v1-png.png";
    return url;
  }
}
